import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';

const PwaSnackbarUpdate = () => {

  const [open, setOpen] = useState(false);
  const handlePWAUpdate = () => setOpen(true);
  useEffect(() => {
    window.addEventListener('pwa-update', handlePWAUpdate);
    navigator.serviceWorker.addEventListener('message', (event) => {
      console.info('snack', event)
      if (event.data.type === 'updateAvailable') {
        setOpen(true);
      }
    });
    return () => {
      window.removeEventListener('pwa-update', handlePWAUpdate);
    }
  }, []);

  const action = (
    <Button
      color="secondary"
      size="small"
      onClick={() => window.location.reload(true)}
    >
      Reload
    </Button>
  );

  return (
    <Snackbar
      style={{ zIndex: 9999999999 }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      message="New update available"
      action={action}
    />
  );
};

export default PwaSnackbarUpdate